import ResponsiveComponent from '@/components/ResponsiveComponent'
import FAQItem from './FAQItem'
import classes from './FAQs.module.scss'
import ResponsiveImage from '@/components/ResponsiveImage'
import { toPlainText } from '@portabletext/toolkit'

const illustrationImgLoader = ({ src }) => {
  return `${src}?w=750`
}

const FAQs = ({ fields, parentClasses }) => {
  const faqEntities = fields?.faqItems
    ?.map((item) => {
      const rawQuestion = item?.question
      const question =
        typeof rawQuestion === 'string'
          ? rawQuestion.trim()
          : Array.isArray(rawQuestion)
            ? toPlainText(rawQuestion).trim()
            : ''
      const rawAnswer = item?.answer
      const answer =
        Array.isArray(rawAnswer)
          ? toPlainText(rawAnswer).trim()
          : typeof rawAnswer === 'string'
            ? rawAnswer.trim()
            : ''

      if (!question || !answer) {
        return null
      }

      return {
        question: question,
        answer: answer,
      }
    })
    .filter(Boolean)

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqEntities
      ?.map((item) => {
        return {
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        }
      })
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqJsonLd),
        }}
      />
      <div className={`${classes['faq']} ${classes[parentClasses]} `}>
        {!!fields?.desktopIllustration && !!fields?.mobileIllustration && (
          <>
          <div className={`${classes['faq__image']}`}>
            <ResponsiveComponent
              desktopBreakpoint={'lg'}
              desktop={
                fields.desktopIllustration?.asset?.url && (
                  <ResponsiveImage
                    loader={illustrationImgLoader}
                    src={fields.desktopIllustration.asset.url}
                    alt={fields.desktopIllustration.asset.alt || 'illustration'}
                  />
                )
              }
              mobile={
                fields.mobileIllustration?.asset?.url && (
                  <ResponsiveImage
                    loader={illustrationImgLoader}
                    src={fields.mobileIllustration.asset.url}
                    alt={fields.mobileIllustration.asset.alt || 'illustration'}
                  />
                )
              }
            />
          </div>
        </>
      )}
      <div className={`${classes['faq__container']} container`}>
        <div className={classes['faq__header']}>
          <h2 className="h1">{fields.header}</h2>
        </div>
        <div className={classes['faq__content']}>
          <ul className={classes['faq__items']}>
            {fields.faqItems?.map((item) => {
              return <FAQItem key={item._id} item={item} />
            })}
          </ul>
        </div>
      </div>
      </div>
    </>
  )
}

export default FAQs
